'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../../external/classnames/index.js');
var slugify = require('../../../utilities/slugify.js');
var index$1 = require('../../../utilities/GatsbyLink/index.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

/**
 *
 * @param {Object} props - The props object for the component.
 * @param {string} [props.className] - Additional CSS classes to apply to the list block.
 * @param {boolean} [props.dividerBottom] - Whether the list block should have a bottom divider.
 * @param {boolean} [props.dividerTop] - Whether the list block should have a top divider.
 * @param {Object[]} [props.items] - The list items to display.
 * @param {string} props.items[].text - The text for the list item.
 * @param {string} [props.items[].url] - The URL for the list item.
 * @param {string} [props.target] - The target attribute for the list items.
 * @param {string} [props.title] - The title for the list block.
 *
 * @example
 * // Defaults dividerBottom=true, dividerTop=true, target='', title='Resources'
 * <ListBlock
 *  title='Resources'
 * items={[
 * {
 * text: 'Item 1',
 * url: 'https://lanl.gov',
 * },
 * {
 * text: 'Item 2',
 * url: 'https://lanl.gov',
 * },
 * ]}
 * />
 *
 * @returns {JSX.Element} The rendered list block component.
 */

var ListBlock = function ListBlock(_ref) {
  var className = _ref.className,
    _ref$dividerBottom = _ref.dividerBottom,
    dividerBottom = _ref$dividerBottom === void 0 ? true : _ref$dividerBottom,
    _ref$dividerTop = _ref.dividerTop,
    dividerTop = _ref$dividerTop === void 0 ? true : _ref$dividerTop,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '' : _ref$target,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Resources' : _ref$title;
  var classes = index.default('list-block', 'lanl-list-block', dividerBottom && 'divider-bottom', dividerTop && 'divider-top', className);
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: classes,
    "data-testid": "lanl-list-block"
  }, /*#__PURE__*/React__default.default.createElement("h3", {
    className: "sidebar-header"
  }, title), /*#__PURE__*/React__default.default.createElement("ul", {
    className: "list-block-ul list-unstyled"
  }, items.map(function (_ref2, index) {
    var text = _ref2.text,
      url = _ref2.url;
    return /*#__PURE__*/React__default.default.createElement("li", {
      className: "list-block-li",
      key: "list-block-".concat(slugify.slugify(title), "-").concat(index)
    }, url ?
    /*#__PURE__*/
    //@ts-expect-error - GatsbyLink is not typed
    React__default.default.createElement(index$1.default, {
      href: url,
      target: target
    }, text) : text);
  })));
};

exports.ListBlock = ListBlock;
exports.default = ListBlock;
//# sourceMappingURL=ListBlock.js.map
